import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ss-logo-solo',
  templateUrl: './logo-solo.component.html',
  styleUrls: ['./logo-solo.component.css'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoSoloComponent {

  @Input() dark = false
}
